var React = require('react');

function IconCheck (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13 0C5.82247 0 0 5.82094 0 13C0 20.1791 5.82247 26 13 26C20.1806 26 26 20.1791 26 13C26 5.82094 20.1806 0 13 0ZM12.9098 18.8362C12.6115 19.1498 12.2078 19.3088 11.804 19.3088C11.4568 19.3088 11.1096 19.1911 10.8236 18.954L5.08835 14.1746L7.04753 11.8254L11.6832 15.6902L18.9173 8.11659L21.1273 10.2302L12.9098 18.8362Z","fill":"currentColor"}));
}

IconCheck.defaultProps = {"viewBox":"0 0 26 26","fill":"none"};

module.exports = IconCheck;

IconCheck.default = IconCheck;
